import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-legacy-data',
   standalone: false,
  templateUrl: './legacy-data.component.html',
  styleUrls: ['./legacy-data.component.scss']
})
export class LegacyDataComponent implements OnInit {

  // cols: any[] = [
  //   { field: 'proposal_name', header: 'Proposal Name', filterType: 'text' },
  //   { field: 'subscheme', header: 'Scheme Name', filterType: 'text' },
  //   { field: 'nodal', header: 'Nodal Directorate', filterType: 'text' },
  //   { field: 'start', header: 'Start Date', filterType: 'date' },
  //   { field: 'end', header: 'End Date', filterType: 'date' }
  // ];
cols = [
  { field: 'name', header: 'Proposal Name' },
  { field: 'scheme_name', header: 'Scheme Name' },
  { field: 'nodal_directorate', header: 'Nodal Directorate' },
  { field: 'start_date', header: 'Start Date' },
  { field: 'end_date', header: 'End Date' },
  { field: 'documents', header: 'Documents' }
];

  system: any[] = [];
  totalRecords = 0;

  showModal = false;
  csvFile: File | null = null;
  zipFile: File | null = null;

  showImportModal = false;
  showEditModal = false;
  title: string = 'Legacy Data';
  selectedRow: any = {};
schemeId: number | null = null;
  constructor(private api: ApiService,
    private route: ActivatedRoute
  ) {}

importMessage: string = '';

ngOnInit() {
  this.getSystem();

  this.route.queryParams.subscribe(params => {
    this.schemeId = params['scheme_id'];
    console.log("SCHEME ID:", this.schemeId);

    if (this.schemeId == 1) {
      this.importMessage =
        'Please upload only Revenue-related legacy proposals here. In the prepared CSV, enter "REVENUE" in the Scheme column.';
    } 
    else if (this.schemeId == 47) {
      this.importMessage =
        'Please upload only MAKE-related legacy proposals here. In the prepared CSV, enter "MAKE 1", "MAKE 2", or "MAKE 3" in the Scheme column.';
    } 
    else if (this.schemeId == 46) {
      this.importMessage =
        'Please upload only IDEX-related legacy proposals here. In the prepared CSV, enter "IDEX ADITI", "IDEX DISC", "IDEX OC", "IDEX 4Fauji", "IDEX Prime", "IDEX INDUS-X" in the Scheme column.';
    } 
    else if (this.schemeId == 16) {
      this.importMessage =
        'Please upload only TDF-related legacy proposals here. In the prepared CSV, enter "TDF" in the Scheme column.';
    }
  });
}
  ngAfterViewInit() {

  document.addEventListener('click', (event: any) => {

    if (event.target.classList.contains('download-icon')) {

      const id = event.target.getAttribute('data-id');

      const row = this.system.find(r => r.id == id);

      if (row) {
        this.downloadDocuments(row);
      }

    }

  });

}
downloadDocuments(row: any) {

  if (!row.briefcase_files || row.briefcase_files.length === 0) {
    alert("No files available");
    return;
  }

  row.briefcase_files.forEach((file: any) => {

    const url = "https://iima-api.ilizien-projects-cdf.in" + file.file_url;

    const link = document.createElement("a");
    link.href = url;
    link.download = file.file_name;
    link.click();

  });

}

  // ✅ GET DATA FROM API
getSystem() {

  this.api.getAPI('/transaction/legacy/data/')
    .subscribe({
      next: (res: any) => {

        const results = res?.data || [];

        this.system = results.map((item: any) => {

          return {
            id: item.id,
            name: item.name,
            scheme_name: item.scheme_name,
            nodal_directorate: item.nodal_directorate,
            start_date: item.start_date,
            end_date: item.end_date,

            // 👇 show value in table
            documents: "Download Files",

            briefcase_files: item.briefcase_files || []
          };

        });

        this.totalRecords = this.system.length;

      },
      error: (err) => console.error(err)
    });

}

downloadCSV(row: any) {

  if (!row.briefcase_files || row.briefcase_files.length === 0) {
    alert("No documents found");
    return;
  }

  const headers = [
    "Proposal Name",
    "Scheme Name",
    "Nodal Directorate",
    "Start Date",
    "End Date",
    "Documents"
  ];

  const documentNames = row.briefcase_files
    .map((f: any) => f.file_name)
    .join(" | ");

  const csvRow = [
    row.name,
    row.scheme_name,
    row.nodal_directorate,
    row.start_date,
    row.end_date,
    documentNames
  ];

  const csvContent =
    headers.join(",") + "\n" +
    csvRow.join(",");

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;
  link.download = `${row.name}_documents.csv`;

  link.click();

}

onCellClick(row: any, column: any) {

  if (column.field === 'documents') {
    this.downloadCSV(row);
  }

}


  // ✅ OPEN MODAL
  openModal() {
    this.showModal = true;
  }

  // ✅ CLOSE MODAL
  closeModal() {
    this.showModal = false;
    this.csvFile = null;
    this.zipFile = null;
  }

  // ✅ FILE UPLOAD
  onCSVUpload(event: any) {
    if (event.target.files.length) {
      this.csvFile = event.target.files[0];
    }
  }

  onZIPUpload(event: any) {
    if (event.target.files.length) {
      this.zipFile = event.target.files[0];
    }
  }

  // ✅ POST API (UPLOAD FILES)
  importData() {
    const formData = new FormData();

    if (this.csvFile) {
      formData.append('legacy_file', this.csvFile);
    }

    if (this.zipFile) {
      formData.append('briefcase_file', this.zipFile);
    }

    this.api.postAPI('/transaction/legacy/data/', formData)
      .subscribe({
        next: (res) => {
          console.log('UPLOAD SUCCESS:', res);

          this.closeModal();

          // 🔥 REFRESH TABLE
          this.getSystem();
        },
        error: (err) => {
          console.error('UPLOAD ERROR:', err);
        }
      });
  }

  // ✅ EDIT
 

  // ✅ DELETE
  showDeletePopup(row: any) {
    console.log('DELETE ROW:', row);
  }
  downloadSampleCSV() {
  const url = 'https://iima-api.ilizien-projects-cdf.in/media/sample_csv/legacy.csv';
  window.open(url, '_blank');
}
editingRowId: number | null = null;

updateSystem(row: any) {
  console.log('Edit row:', row);

  // send row id to child via input (next step)
  this.editingRowId = row.id;
  this.openEditModal(row);
}


  openImportModal() {
    this.showImportModal = true;
  }

  closeImportModal() {
    this.showImportModal = false;
    this.csvFile = null;
    this.zipFile = null;
  }



  

  // ================= EDIT POPUP =================

openEditModal(row: any) {

  this.selectedRow = { ...row };

  this.selectedRow.start_date = this.formatDate(row.start_date);
  this.selectedRow.end_date = this.formatDate(row.end_date);

  this.showEditModal = true;
}
formatDate(date: string) {

  if (!date) return '';

  const parts = date.split('-');

  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

  closeEditModal() {
    this.showEditModal = false;
    this.showModal = false;
  }

updateLegacy() {

  const payload = {

    name: this.selectedRow.name,
    description: this.selectedRow.description,
    scheme_name: this.selectedRow.scheme_name,
    start_date: this.selectedRow.start_date,
    end_date: this.selectedRow.end_date,
    nodal_directorate: this.selectedRow.nodal_directorate,
    nodal_officer: this.selectedRow.nodal_officer,
    legacy_ser: this.selectedRow.legacy_ser

  };

  this.api.putAPI(`/transaction/legacy/data/${this.selectedRow.id}/`, payload)
    .subscribe(res => {

      console.log('UPDATE SUCCESS', res);

      this.closeEditModal();
      this.getSystem();

    });

}


}


